import React from "react";
import { Helmet } from "react-helmet";
// import img1 from "../../../assets/islam/img-title/กฎหมายมรดก.png";
import "./posts-islam.css"

const มรดก = () => {
  const TITLE = "กฎหมายมรดกอิสลาม";

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <br></br>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>กฎหมายมรดก ( الفرائض)</b> ในศาสนาอิสลามได้กำหนดให้ทั้งชายและหญิงสามารถถือกรรมสิทธิ์ได้ ภายใต้ข้อกำหนดและกฎเกณฑ์ของอิสลาม ซึ่งพระมหาคัมภีร์อัลกุรอานได้อธิบายถึงเกณฑ์ต่าง ๆ ของการแบ่งมรดก 
          สถานะภาพของผู้รับมรดกอย่างครบถ้วนสมบูรณ์ โดยมิได้ปล่อยช่องว่างไว้ให้ผู้หนึ่งผู้ใดทำการกำหนดการแบ่งมรดกได้ด้วยตนเอง{" "}
        </p>

        {/* 1. ความสำคัญของวิชามรดกในศาสนาอิสลาม */}
        <div>
          <h2 id="initial-header">1. ความสำคัญของวิชามรดกในศาสนาอิสลาม</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>วิชาการแบ่งมรดก</b> เป็นรายวิชาที่สำคัญอย่างยิ่ง อันเนื่องจากความสำคัญของรายวิชานี้อัลลอฮฺได้ทรงจัดแบ่งด้วยตัวพระองค์เอง โดยรายละเอียดต่าง ๆ ได้ถูกอธิบายไว้บนพระคัมภีร์ของพระองค์ 
            และได้ให้ความเท่าเทียมกันระหว่างทายาทผู้รับมรดกเพื่อให้ดำเนินไปด้วยความยุติธรรมและเกิดผลประโยชน์ซึ่งพระองค์อัลลอฮฺทรงรอบรู้ดี
          </p>
        </div>

        {/* 2. หน้าที่ของมุสลิมที่มีต่อมรดกอิสลาม */}
        <div>
        <h2 id="second-header">2. หน้าที่ของมุสลิมที่มีต่อมรดกอิสลาม</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;มุสลิมทุกนคจำเป็นต้องแบ่งมรดกให้เป็นไปตามกฎเกณฑ์ของมรดกอิสลาม <mark className=" bg-[#fee9b2] rounded-xl">หากบุคคลใดไม่ปฏิบัติตามถือว่าเขาผู้นั้นเป็นผู้ฝ่าฝืนและละเมิดต่อบทบัญญัติของอัลลอฮฺ (ซ.บ.)  </mark>{" "}
          {/* <img
            src={img1}
            alt="มรดก"
            className="w-11/12 block ml-auto mr-auto"
          /> */}
        </p>
        </div>

        {/* 3. ความหมายของกฎหมายมรดกและทรัพย์มรดก */}
        <h2 id="third-header">3. ความหมายของกฎหมายมรดกและทรัพย์มรดก</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>กฎหมายมรดก</b> หมายถึง ความเข้าใจในเรื่องทรัพย์สินที่เป็นมรดก ผู้เป็นทายาท 
          ส่วนแบ่งที่ทายาทแต่ละคนจะได้รับและความรู้เกี่ยวกับการคำนวณที่นำไปสู่การรู้ถึงจำนวนส่วนได้ของแต่ละคนที่มีสิทธิ์รับมรดกจากกองมรดก
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>ทรัพย์มรดก</b> หมายถึง ทรัพย์สินที่เป็นทั้งอสังหาและสังหาริมทรัพย์ซึ่งรวมถึงสิทธิต่าง ๆ ที่ตกทอดแก่ทายาทตามหลักกฎหมายอิสลาม
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>มรดก</b> หมายถึง ทรัพย์สินหรือสิทธิที่ผู้ตายได้ทิ้งไว้ ซึ่งผู้ที่มีสิทธิรับคือทายาทโดยธรรมตามหลักศาสนบัญญัติ โดยมีสิทธิได้รับด้วยการสิ้นชีวิตของผู้ตาย
        </p>
        
        {/* 4. บรรดาสิทธิที่เกี่ยวพันกับทรัพย์มรดกของผู้ตาย */}
        <h2 id="fourth-header">4. บรรดาสิทธิที่เกี่ยวพันกับทรัพย์มรดกของผู้ตาย</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            เนื่องจากว่าสิทธิที่เกี่ยวพันกับทรัพย์มรดกของผู้ตายได้เป็นที่ถกเถียงกันในหมู่นักปราชญ์ โดยถูกแบ่งออกเป็น 2 กลุ่ม คือ กลุ่มนักปราชญ์ส่วนน้อย 
            และกลุ่มนักปราชญ์ส่วนใหญ่ รวมไปถึง 4 มัสฮับ <mark className=" bg-[#fee9b2] rounded-xl">โดยทางผู้จัดทำได้จัดทำตามกลุ่มนักปราชญ์ส่วนใหญ่ที่รวมกับมัสฮับทั้ง 4 ซึ่งได้แบ่งสิทธิที่เกี่ยวพันกับทรัพย์มรดกของผู้ตายไว้ 4 ข้อ</mark>{" "}
            คือ  
            <ul className=" list-decimal ml-12 mb-3">
              <li><b>การจัดการศพ</b> หมายถึง ค่าใช้จ่ายทั้งหมดนับตั้งแต่การเสียชีวิตของผู้ตายจวบจนเสร็จสิ้นการฝังศพ</li>
              <li><b>หนี้</b> บรรดาหนี้สินที่เกี่ยวพันกับตัวของทรัพย์มรดกก่อนหน้าการเสียชีวิตของผู้ตาย อาทิ เช่น การจำนอง การซื้อขาย และทรัพย์สินซึ่งจำเป็นต้องออกซะกาฮฺ 
                และบรรดาหนี้สินที่มีภาระผูกพันกับผู้ตาย ไม่ว่าบรรดาหนี้สินนั้นจะเป็นสิทธิของพระองค์อัลลอฮฺ เช่น ซะกาฮฺ, สิ่งที่ถูกบน (นะซัร) เอาไว้ หรือจะเป็นสิทธิของบ่าว 
                เช่น การยืมหนี้สิน เป็นต้น 
              </li>
              <li><b>พินัยกรรม (วะศียะฮฺ)</b>ที่ผู้ตายทำเอาไว้จากจำนวน 1 ใน 3 ของทรัพย์สินที่ผู้ตายละทิ้งไว้ หลังจากค่าใช้จ่ายในการจัดการศพ และการชดใช้หนี้สินของผู้ตาย </li>
              <li><b>ทรัพย์อันเป็นมรดก</b> ซึ่งถือเป็นสิทธิที่เกี่ยวพันกับทรัพย์สินของผู้ตายในลำดับท้ายสุด โดยให้นำมาแบ่งระหว่างทายาทผู้มีสิทธิรับมรดกตามสัดส่วนที่ศาสนากำหนด</li>
            </ul>                                                                                                                                                                                                                               
            <b>หมายเหตุ: </b>โดยในข้อที่ 1. การจัดงานศพ และ 2. หนี้ ยังเป็นที่ถกเถียงกันในหมู่ของ 4 มัสฮับ ในการจัดความสำคัญระหว่างข้อที่ 1 และ 2 
            ซึ่งข้อถกเถียงดังกล่าวถูกแบ่งออกเป็น 2 กลุ่ม โดยกลุ่มแรก คือ มัสฮับฮัมบาลี ให้จัดการในส่วนของการจัดการศพก่อนการจ่ายหนี้ 
            (บรรดาหนี้สินเกี่ยวพันกับตัวของทรัพย์มรดก และบรรดาหนี้สินที่มีภาระผูกพันกับผู้ตาย) กลุ่มที่สองคือ มัสฮับซาฟีอี มาลีกี และฮานาฟี 
            ได้ให้จัดการในส่วนหนี้เกี่ยวพันกับตัวของทรัพย์มรดกก่อนการจัดการศพ และตามด้วยการจัดการบรรดาหนี้สินที่มีภาระผูกพันกับผู้ตาย
            <mark className=" bg-[#fee9b2] rounded-xl"> แต่ทั้ง 2 กลุ่มได้ให้ความเห็นในทางเดียวกันคือให้จัดการสิทธิที่เกี่ยวพันกับทรัพย์มรดกของผู้ตายออกเป็น 4 ข้อเท่านั้น ไปพร้อมกับกลุ่มนักปราชญ์ส่วนใหญ่ที่เห็นพ้องเช่นเดียวกัน</mark>{" "}
          </p>

        {/* 5. องค์ประกอบของการแบ่งมรดก */}
        <h2 id="fifth-header">5. องค์ประกอบของการสืบมรดก</h2>
          <p> 
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
            องค์ประกอบของการแบ่งมรดกจำเป็นต้องมีให้ครบ 3 ข้อ 
            เนื่องจากการสืบมรดกนั้นเป็นการที่บุคคลหนึ่งได้รับสิทธิในการครอบครองทรัพย์สินของอีกบุคคล 
            หากขาดสิ่งใดสิ่งหนึ่งไปก็จะไม่มีการสืบมรดก โดยองค์ประกอบของการสืบมรดกถูกแบ่งออกเป็น 3 ข้อ ดังนี้
            <br></br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            1. เจ้ามรดก
            <br></br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            2. ทายาทหรือผู้สืบมรดก
            <br></br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            3. ทรัพย์มรดก
          </p>

        {/* 6. เงื่อนไขของการสืบมรดก  */}
        <h2 id="sixth-header">6. เงื่อนไขของการสืบมรดก</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ก่อนการแบ่งมรดกของผู้ตายให้แก่ทายาทของเขาจะต้องตรวจสอบดูเงื่อนไขในการสืบมรดกว่ามีครบทุกข้อหรือไม่ 
            ซึ่งการแบ่งมรดกมีเงื่อนไขอยู่ 3 ประการด้วยกัน ดังนี้
            <ul className=" list-decimal ml-12 mb-3">
              <li>ทายาทผู้รับมรดกมีชีวิตอยู่จริงภายหลังจากการตายของเจ้าของมรดก</li>
              <li>เจ้าของทรัพย์มรดกได้เสียชีวิตจริง หรือด้วยการตัดสินของกอฎี (ผู้พิพากษา) ว่าเสียชีวิต</li>
              <li>ความรู้เกี่ยวกับการแบ่งมรดก</li>
            </ul>
          </p>

        {/* 7. สาเหตุของการมีสิทธิ์รับมรดก */}
        <h2 id="seventh-header">7. สาเหตุของการมีสิทธิ์รับมรดก</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            สาเหตุที่ทำให้บุคคลได้รับมรดกจากผู้ที่เสียชีวิตมี 3 ประการ
            <ul className=" list-decimal ml-16 mb-3">
              <li>การเป็นญาติที่มีความสัมพันธ์ทางการสืบสายโลหิต</li>
              <li>การสมรส จะต้องเป็นการสมรสที่เป็นไปตามหลักการอิสลามเท่านั้น</li>
              <li>การปล่อยทาส เนื่องจากเมื่อนายทาสได้ปล่อยทาสให้เป็นไทแล้ว ทำให้เกิดความสัมพันธ์ระหว่างบุคคลทั้งสองฉันท์เครือญาติ ศาสนาอิสลามจึงได้ตอบแทนผู้เป็นนายด้วยการให้เขามีสิมธิ์รับมรดกของทาส 
                หากเมื่อทาสผู้นั้นได้เสียชีวิตไป
              </li>
            </ul>
          </p>


        {/* 8. การกำจัดสิทธิจากกองมรดก */}
        <h2 id="eight-header">8. การกำจัดสิทธิจากกองมรดก</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            สิ่งที่ทำให้ทายาทถูกจำกัดสิทธิจากกองมรดกคือ ลักษณะต่าง ๆ ที่เกิดขึ้นในทายาทที่จะรับมรดก ซึ่งทำให้เขาถูกตัดสิทธิจากการรับมรดกมี 3 ประการ ดังนี้
            <ul className=" list-decimal ml-12 mb-3">
              <li><b>การเป็นทาส</b> ผู้ที่เป็นทาสจะไม่มีสิทธิในการรับมรดกจากทางญาติของเขาที่เสียชีวิตได้ เนื่องจากทรัพย์มรดกดังกล่าวจะตกเป็นของนายของเขาทันที ซึ่งนายของเขาไม่ได้มีความสัมพันธ์และเป็นญาติกับผู้ตายแต่ประการใด</li>
              <li><b>การฆ่า</b> เมื่อผู้เป็นทายาทได้ฆ่าผู้เป็นเจ้ามรดกแล้ว ทายาทผู้นั้นจะไม่มีสิทธิรับมรดกจากทรัพย์ของเจ้ามรดกเลย</li>
              <li><b>ความแตกต่างในเรื่องการนับถือศาสนา</b> มุสลิมจะไม่ได้รับมรดกของผู้ที่นับถือศาสนาอื่น และเขาก็จะไม่มีสิทธิ์รับมรดกของมุสลิมเช่นกัน</li>
            </ul>
          </p>
      </div>

      <div>
        <h1 className="ml-4">แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
          <li>
            <a className="text-indigo-700 underline" href="/islam/2">
              ทายาทที่มีสิทธิและเสียสิทธิรับมรดก
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/3">
            วิธีการคำนวณมรดกอิสลาม
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/4">
              การแบ่งมรดกกรณีพิเศษ
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/5">
              บทบัญญัติที่ถูกกล่าวถึงในกฎหมายมรดก
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/6">
              พินัยกรรม
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default มรดก;
